import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../utils/cn.js';
// Soft = tinted-warm chip with tone-coloured text (default; low emphasis).
// Solid = filled tone (high emphasis — active / overdue / etc.).
const SOFT = {
    neutral: 'bg-paper-warm text-ink-muted border-border',
    forest: 'bg-paper-warm text-forest border-border',
    success: 'bg-paper-warm text-success border-border',
    warning: 'bg-paper-warm text-warning border-border',
    danger: 'bg-paper-warm text-danger border-border',
    gold: 'bg-paper-warm text-gold border-border',
};
const SOLID = {
    neutral: 'bg-ink-soft text-ink border-transparent',
    forest: 'bg-forest text-paper border-transparent',
    success: 'bg-leaf text-paper border-transparent',
    warning: 'bg-sun text-ink border-transparent',
    danger: 'bg-danger text-paper border-transparent',
    gold: 'bg-gold text-paper border-transparent',
};
/**
 * Status pill — the one primitive for statuses, tags, and counts across the
 * apps. `soft` (default) is a low-emphasis warm chip; `solid` fills with the
 * tone for states that must catch the eye (ACTIVE, OVERDUE).
 */
export function Badge({ tone = 'neutral', variant = 'soft', className, children, ...rest }) {
    return (_jsx("span", { className: cn('inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 font-body text-xs font-medium', variant === 'solid' ? SOLID[tone] : SOFT[tone], className), ...rest, children: children }));
}
//# sourceMappingURL=Badge.js.map